document.addEventListener("click", (t) => {
  const e = t.target.closest(".accordion__item--question");
  if (e)
    return ((t) => {
      const e = t.closest(".faq-accordion__item"),
        o = e.querySelector(".accordion__item--answer");
      if (e.classList.contains("active")) o.style.maxHeight = 0;
      else {
        const t = o.scrollHeight;
        var s = window.getComputedStyle(o).getPropertyValue("margin-top");
        const e = t + parseFloat(s);
        o.style.maxHeight = e + "px";
      }
      e.classList.toggle("active");
    })(e);
});
